"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _InfoBubble_css = _interopRequireDefault(require("./InfoBubble_css"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _modalUtils = require("../utils/modalUtils");
var _getElementDimensions = _interopRequireDefault(require("../utils/getElementDimensions"));
var _lodash = require("lodash");
var _getElementPosition = _interopRequireDefault(require("../utils/getElementPosition"));
// Breaks IE 11 for some reason...

class InfoBubble extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "setupHover", () => {
      if (!this.props.openOnHover) {
        this.anchorElem.removeEventListener("mouseenter", this.handleTriggerHoverIn);
        this.anchorElem.removeEventListener("focus", this.handleTriggerHoverIn);
        this.anchorElem.removeEventListener("mouseleave", this.handleTriggerHoverOut);
        this.anchorElem.removeEventListener("blur", this.handleTriggerHoverOutOnBlur);
        return;
      }
      this.anchorElem.addEventListener("mouseenter", this.handleTriggerHoverIn);
      this.anchorElem.addEventListener("focus", this.handleTriggerHoverIn);
      this.anchorElem.addEventListener("mouseleave", this.handleTriggerHoverOut);
      this.anchorElem.addEventListener("blur", this.handleTriggerHoverOutOnBlur);
    });
    /**
     * @description: This will create a transparent overlay the same size and
     * position as the anchor element, then place itself on top. This will be
     * used for binding mouse event listeners to properly open/close the bubble
     * on "hover". The trigger overlay should be at least as big as the trigger,
     * but also connect to the InfoBubble so there are no "gaps" between the
     * two so that leaving the trigger overlay to enter the InfoBubble doesn't
     * result in any unexpected closing of InfoBubble.
     */
    (0, _defineProperty2.default)(this, "createTriggerHoverOverlay", () => {
      this.anchorOverlay = document.createElement("div");
      const anchorData = {
        position: (0, _getElementPosition.default)(this.anchorElem),
        size: (0, _getElementDimensions.default)(this.anchorElem)
      };
      const {
        top,
        marginTop
      } = this.state.positionStyles;
      const isTopAligned = top > anchorData.position.y;
      const overlayTop = isTopAligned ? anchorData.position.y : top + marginTop; // Margin top will be negative when top aligned
      const height = anchorData.size.h + Math.abs(marginTop);
      this.anchorOverlay.classList.add("InfoBubble-triggerOverlay");
      this.anchorOverlay.style = `
      height: ${height}px;
      left: ${anchorData.position.x}px;
      position: absolute;
      top: ${overlayTop}px;
      width: ${anchorData.size.w}px;
      z-index: 102;
    `;
      this.anchorOverlay.addEventListener("mouseenter", this.handleTriggerOverlayHoverIn);
      this.anchorOverlay.addEventListener("mouseleave", this.handleTriggerOverlayHoverOut);
      document.body.appendChild(this.anchorOverlay);
    });
    /**
     * @description: Clean up trigger hover overlay, for use on close.
     */
    (0, _defineProperty2.default)(this, "removeTriggerHoverOverlay", () => {
      document.body.removeChild(this.anchorOverlay);
      this.anchorOverlay.removeEventListener("mouseenter", this.handleTriggerOverlayHoverIn);
      this.anchorOverlay.removeEventListener("mouseleave", this.handleTriggerOverlayHoverOut);
      this.anchorOverlay = null;
    });
    /**
     * @description: Handler for trigger "hover" over event. Creates trigger
     * overlay, with its own event handlers for the "hover" effect.
     */
    (0, _defineProperty2.default)(this, "handleTriggerHoverIn", () => {
      this.setState({
        isTriggerHovered: true
      });
      this.openBubble();
    });
    /**
     * @description: Handler for trigger "hover" out event. Only changes state.
     */
    (0, _defineProperty2.default)(this, "handleTriggerHoverOut", () => {
      this.setState({
        isTriggerHovered: false
      });
    });
    /**
     * @description: Handler for trigger "blur" event.
     */
    (0, _defineProperty2.default)(this, "handleTriggerHoverOutOnBlur", () => {
      this.handleTriggerHoverOut();
      this.close();
    });
    /**
     * @description: Sets flag that trigger overlay is hovered so that hovering
     * off bubble does NOT close bubble.
     */
    (0, _defineProperty2.default)(this, "handleTriggerOverlayHoverIn", () => {
      if (!this.state.isTriggerOverlayHovered) this.setState({
        isTriggerOverlayHovered: true
      });
    });
    /**
     * @description: Closes bubble if trigger overlay and bubble are both no
     * longer hovered. Also updates state that trigger overlay is no longer
     * hovered.
     */
    (0, _defineProperty2.default)(this, "handleTriggerOverlayHoverOut", (0, _lodash.debounce)(() => {
      if (this.state.isHovered) {
        this.setState({
          isTriggerOverlayHovered: false
        });
      } else {
        this.close();
      }
    }, this.props.hoverCloseDelay));
    /**
     * @description: Sets flag that bubble is hovered so that hovering off
     * trigger overlay does NOT close bubble.
     */
    (0, _defineProperty2.default)(this, "handleBubbleHoverIn", () => {
      if (!this.state.isHovered) this.setState({
        isHovered: true
      });
    });
    /**
     * @description: Closes bubble if trigger overlay and bubble are both no
     * longer hovered. Also updates state that bubble is no longer hovered.
     */
    (0, _defineProperty2.default)(this, "handleBubbleHoverOut", (0, _lodash.debounce)(() => {
      if (this.state.isTriggerOverlayHovered) {
        this.setState({
          isHovered: false
        });
      } else {
        this.close();
      }
    }, this.props.hoverCloseDelay));
    /**
     * @description: Prevent clicks on trigger overlay from closing/reopen the
     * InfoBubble.
     */
    (0, _defineProperty2.default)(this, "handleTriggerOverlayClick", clickEvent => {
      clickEvent.stopPropagation();
      return;
    });
    (0, _appendCss.default)("arc_infobubble", _InfoBubble_css.default);

    // get the element the flyout will be injected into
    this.modalRoot = (0, _modalUtils.getModalRoot)();

    // Create a div that we'll render the modal into. Because each
    // InfoBubble component has its own element, we can render multiple
    // InfoBubble components into the modal container.
    this.el = document.createElement("div");
    this.anchorElem = null;

    // The anchor overlay is for handing mouse events when the InfoBubble is
    // set to `openOnHover`.
    this.anchorOverlay = null;
    this.applyWrapper = this.applyWrapper.bind(this);
    this.checkIfIsControlled = this.checkIfIsControlled.bind(this);
    this.keyboardHandler = this.keyboardHandler.bind(this);
    this.close = this.closeFlyout.bind(this);
    this.getTargetWidth = this.getTargetWidth.bind(this);
    this.handleAnchorClick = this.handleAnchorClick.bind(this);
    this.openBubble = this.openBubble.bind(this);
    this.setEvents = this.setEvents.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.state = {
      anchorStyles: {},
      isControlled: false,
      isHovered: false,
      // the actual bubble and its content
      isTriggerOverlayHovered: false,
      // the mask that floats on-top (z-index) of the trigger
      isTriggerHovered: false,
      // the trigger
      isOpen: false,
      positionStyles: {}
    };
  }
  checkIfIsControlled(prevProps) {
    if (this.props.isOpen === true || this.props.isOpen === false) return true;
    return false;
  }
  componentDidMount() {
    if (!this.props.anchorId) {
      return;
    }
    this.setEvents();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
      this.openBubble();
    }
    if (prevProps.anchorId !== this.props.anchorId) this.setPosition();
  }
  componentWillUnmount() {
    this.unsetEvents();
  }
  keyboardHandler(e) {
    if (e.keyCode === 27) {
      // ESC key
      this.close();
    }
  }
  setEvents() {
    this.anchorElem = document.getElementById(this.props.anchorId);
    if (this.checkIfIsControlled() && this.state.isControlled === false) {
      // No reason to bind events since bubble is controlled
      return this.setState({
        isControlled: true,
        isOpen: this.props.isOpen
      });
    }
    if (!this.anchorElem) {
      setTimeout(() => {
        this.setEvents();
      }, 200);
    } else {
      if (this.props.openOnHover) {
        this.setupHover();
      } else {
        this.anchorElem.addEventListener("click", this.handleAnchorClick);
        this.anchorElem.addEventListener("keydown", this.keyboardHandler);
        this.anchorElem.addEventListener("blur", this.close);
      }
      this.anchorElem.setAttribute("aria-haspopup", "true");
      this.anchorElem.setAttribute("aria-expanded", "false");
    }
  }
  unsetEvents() {
    // try to grab the anchor element again, just in case it too has unmounted
    this.anchorElem = document.getElementById(this.props.anchorId);
    if (this.anchorElem) {
      this.anchorElem.removeEventListener("click", this.handleAnchorClick);
      this.anchorElem.removeEventListener("keydown", this.keyboardHandler);
      this.anchorElem.removeEventListener("blur", this.close);
      if (this.props.openOnHover) {
        this.anchorElem.removeEventListener("mouseenter", this.handleTriggerHoverIn);
        this.anchorElem.removeEventListener("focus", this.handleTriggerHoverIn);
        this.anchorElem.removeEventListener("mouseleave", this.handleTriggerHoverOut);
        this.anchorElem.removeEventListener("blur", this.handleTriggerHoverOutOnBlur);
      }
    }
  }
  openBubble() {
    if (!this.state.isOpen) {
      // Append the element into the DOM on click. We'll render
      // into the modal container element.
      this.modalRoot.appendChild(this.el);
      this.setPosition();
      if (!this.state.isControlled) {
        if (this.props.openOnHover) {
          setTimeout(() => {
            if (this.state.isTriggerHovered) {
              this.createTriggerHoverOverlay();
              this.setState({
                isOpen: true
              });
            }
          }, this.props.hoverOpenDelay);
        } else {
          this.setState({
            isOpen: true
          });
        }
        setTimeout(() => {
          document.body.addEventListener("click", this.close);
        }, 200);
        // just need a slight delay when attaching the listener
      }
    }
    this.anchorElem.setAttribute("aria-expanded", "true");
  }
  handleAnchorClick() {
    this.openBubble();
  }
  applyWrapper() {
    const infoClasses = (0, _classnames.default)(`InfoBubble--${this.props.variant}`, {
      [this.props.className]: this.props.className
    });
    const flyoutClasses = (0, _classnames.default)({
      "InfoBubble--flyout": true,
      [this.flyoutPositionClass]: this.flyoutPositionClass,
      "fixed-position": this.props.fixedPosition,
      "isAnimated": this.props.isAnimated
    });
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: infoClasses,
      onMouseEnter: this.props.openOnHover ? this.handleBubbleHoverIn : null,
      onMouseLeave: this.props.openOnHover ? this.handleBubbleHoverOut : null,
      role: "tooltip"
    }, this.props.describedById ? {
      id: this.props.describedById
    } : {}), /*#__PURE__*/_react.default.createElement("div", {
      className: flyoutClasses,
      style: this.state.positionStyles
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "InfoBubble--pointerMask"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `InfoBubble--content ${this.props.variant === "light" ? "t-body-small" : "t-label-med"}`
    }, this.props.children))));
  }
  closeFlyout(evt) {
    if (this.props.onClose !== null) this.props.onClose(evt);
    if (!this.state.isControlled) {
      // need a slight delay before finishing the close behaviors, simply to give the onClick prop time to fire.
      setTimeout(() => {
        if (this.state.isTriggerOverlayHovered || this.state.isHovered) {
          this.removeTriggerHoverOverlay();
        }
        this.setState({
          isHovered: false,
          // ensure hover states get cleaned up
          isOpen: false,
          isTriggerOverlayHovered: false // ensure hover states get cleaned up
        });
        document.body.removeEventListener("click", this.close);
        if (this.modalRoot.contains(this.el)) {
          this.modalRoot.removeChild(this.el);
        }
      }, 150);
    }
    this.anchorElem.setAttribute("aria-expanded", "false");
  }
  setPosition() {
    let pointerOffset = 8;
    let positionStyles = (0, _modalUtils.setFlyoutPosition)(this.anchorElem, this.props.alignment, this.props.offset, pointerOffset, this.props.fixedPosition);
    this.flyoutPositionClass = this.props.alignment;
    positionStyles.width = this.props.width || this.getTargetWidth();
    this.setState({
      positionStyles
    });
  }
  getTargetWidth() {
    let dim = (0, _getElementDimensions.default)(this.anchorElem);
    return dim.w;
  }
  render() {
    // Use a portal to render the children into the element
    if (!this.state.isControlled && !this.state.isOpen || this.state.isControlled && !this.props.isOpen) return null;
    return /*#__PURE__*/_reactDom.default.createPortal(
    // Any valid React child: JSX, strings, arrays, etc.
    this.applyWrapper(),
    // A DOM element
    this.el);
  }
}
exports.default = InfoBubble;
InfoBubble.propTypes = {
  /** Which edge of the anchor element to align the flyout to. One of ["bottomLeft", "bottomRight", "bottomCentered", "topLeft", "topRight", "topCentered, "leftTop", "leftMiddle", "leftBottom","] */
  alignment: _propTypes.default.oneOf(["bottomLeft", "bottomRight", "bottomCentered", "topLeft", "topRight", "topCentered", "leftTop", "leftMiddle", "leftBottom"]),
  /** The id for the element to anchor to. Also used to attach a click event to open the InfoBubble */
  anchorId: _propTypes.default.string.isRequired,
  /** The id for the InfoBubble's anchor "aria-describedby" attribute */
  describedById: _propTypes.default.string,
  /** Specify light or dark mode  */
  variant: _propTypes.default.oneOf(["light", "dark"]),
  /** A css class name added to the this instance of the flyout */
  className: _propTypes.default.string,
  /** Boolean to tell the bubble that the anchor is, or is within, a fixed/absolute positioned element. */
  fixedPosition: _propTypes.default.bool,
  /** Milliseconds before closing bubble when hovering off trigger/InfoBubble. */
  hoverCloseDelay: _propTypes.default.number,
  /** Milliseconds before opening bubble when hovering the trigger. */
  hoverOpenDelay: _propTypes.default.number,
  /** Switch to controlled component by setting true. */
  isOpen: _propTypes.default.bool,
  /** Positive or negative x/y number to adjust margin relative to alignment */
  offset: _propTypes.default.shape({
    /** offset.x: number value that will translate to margin-left or margin-right depending on alignment */
    x: _propTypes.default.number,
    /** offset.y: number value that will translate to margin-top or margin-bottom depending on alignment */
    y: _propTypes.default.number
  }),
  /** Function to call onClose of bubble */
  onClose: _propTypes.default.func,
  /** Set InfoBubble to open/close when hovering on trigger. Requires `triggerId` prop. */
  openOnHover: _propTypes.default.bool,
  /** A css size value for setting the bubble width. Defaults to anchor elements width */
  width: _propTypes.default.string,
  /** Boolean to enable or disable animation */
  isAnimated: _propTypes.default.bool
};
InfoBubble.defaultProps = {
  describedById: null,
  alignment: "topCentered",
  className: "",
  fixedPosition: false,
  hoverCloseDelay: 100,
  // Slow enough for state updates. Fast enough for UX.
  hoverOpenDelay: 500,
  isOpen: null,
  offset: {
    x: 0,
    y: 0
  },
  onClose: null,
  openOnHover: false,
  variant: "dark",
  width: null,
  isAnimated: true
};